import React, { Component, Fragment } from 'react';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { compose } from 'recompose';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core';
import { Badge, IconButton, Popover, Toolbar, Typography, MenuItem, Menu, Hidden } from '@material-ui/core';
import {
  Menu as MenuIcon,
  // Close as CloseIcon,
  ArrowBack as ArrowBackIcon,
  NotificationsOutlined as NotificationsIcon,
  // Input as InputIcon,
  AccountCircleOutlined as AccountIcon
} from '@material-ui/icons';

// import { getNotifications } from 'services/notification';
import { history } from 'utils/history';
import { canAccess, getCurrentAccount } from 'utils/helpers';
import { ENABLE_MULTILANGUAGE } from 'utils/config';

import { LocaleSwitcher, HelpMenu, PrintManagerMenu, NotificationMenu } from 'components';

import { logout } from 'views/Users/_actions';
import { userService } from 'views/Users/_services';
import { openAccountDialog } from 'views/App/_actions';

import styles from './styles';

class Topbar extends Component {
  signal = true;
  timer = null;

  state = {
    userMenuAnchorEl: null,
    isUserMenuOpen: false
  };

  handleSignOut = () => {
    const { dispatch } = this.props;

    dispatch(logout());
  };

  handleUserMenu = event => {
    this.setState({ userMenuAnchorEl: event.currentTarget, isUserMenuOpen: true });
  };

  handleUserMenuClose = () => {
    this.setState({ userMenuAnchorEl: null, isUserMenuOpen: false });
  };

  handleAccountSwitch = () => {
    const { dispatch } = this.props;
    this.handleUserMenuClose();

    dispatch(openAccountDialog());
  };

  handleCreateAccount = () => {
    // const { history } = this.props;

    // history.push('/companies/join');

    window.location.href = '/companies/join';
  };

  handleProfile() {
    history.push('/profile');
  }

  handleCompanyEdit() {
    const { company } = getCurrentAccount();

    if (!company) {
      return;
    }

    history.push(`/companies/${company._id}`);
  }

  render() {
    const { classes, className, title, titleComponent, isSidebarOpen, onToggleSidebar, onBackButton, currentAccount, user, t } = this.props;
    const { userMenuAnchorEl, isUserMenuOpen } = this.state;
    const rootClassName = classNames(classes.root, className, 'top-navbar');

    return (
      <Fragment>
        <div className={rootClassName}>
          <Toolbar className={classes.toolbar}>
            {/* Sidebar collapse button */}
            {!isSidebarOpen ? (
              <IconButton className={classes.menuButton} onClick={onToggleSidebar} variant="text">
                <MenuIcon />
              </IconButton>
            ) : null}
            {/* Back button */}
            <IconButton className={classes.menuButton} onClick={onBackButton} variant="text" title={t('Grįžti')}>
              <ArrowBackIcon />
            </IconButton>
            {/* Title */}
            <Typography className={classes.title} variant="h5">
              {title} {titleComponent}
            </Typography>

            <HelpMenu className={classes.helpButton} />

            <PrintManagerMenu />

            <NotificationMenu />

            {ENABLE_MULTILANGUAGE && <LocaleSwitcher />}

            {/* User menu */}
            <div>
              <IconButton aria-controls="menu-accounts" aria-haspopup="true" onClick={this.handleUserMenu}>
                <AccountIcon />
              </IconButton>
              <Menu
                id="menu-accounts"
                anchorEl={userMenuAnchorEl}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right'
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right'
                }}
                open={isUserMenuOpen}
                onClose={this.handleUserMenuClose}>
                <MenuItem onClick={this.handleAccountSwitch} id="li-accounts">
                  {t('Paskyros')}
                </MenuItem>
                <MenuItem onClick={this.handleCreateAccount} id="li-accounts-create">
                  {t('Sukurti naują paskyrą')}
                </MenuItem>
                <MenuItem onClick={this.handleProfile}>{t('Profilio duomenys')}</MenuItem>
                {canAccess('companies.write') ? <MenuItem onClick={this.handleCompanyEdit}>{t('Įmonės duomenys')}</MenuItem> : null}
                <MenuItem onClick={this.handleSignOut}>{t('Atsijungti')}</MenuItem>
              </Menu>
            </div>

            {currentAccount ? (
              <div title={user ? user.email : null}>
                <Typography variant="body2">{user ? user.fullName : null}</Typography>

                <Hidden xsDown>
                  <Typography variant="body2">
                    {/* {user ? user.email : null} */}
                    {currentAccount.position}
                  </Typography>
                </Hidden>

                <Typography variant="caption" display="block">
                  {currentAccount.company ? `${currentAccount.company.name} ${currentAccount.company.department || ''}` : t('Įmonė nenurodyta')}
                </Typography>
              </div>
            ) : null}
          </Toolbar>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = ({ app, dispatch }) => {
  return { dispatch, ...app };
};

Topbar.defaultProps = {
  onToggleSidebar: () => { }
};

export default compose(
  withRouter,
  withStyles(styles),
  connect(mapStateToProps),
  withTranslation()
)(Topbar);
